import {
  Box,
  Button,
  ControllerDataGrid,
  GridColDef,
  GridRenderCellParams,
  GridRowsProp,
  MdDelete,
  Typography,
} from '@bymason-private/legacy-pattern-components';
import { ApiKeysModel } from '@bymason/controller-api-hooks';

interface ApiKeysRenderProps {
  apiKeys?: ApiKeysModel[];
  handleDeleteApiKeyModalOpen: (key: ApiKeysModel) => void;
}

export function ApiKeysList({ apiKeys, handleDeleteApiKeyModalOpen }: ApiKeysRenderProps) {
  const RenderDeleteButton = (params: GridRenderCellParams) => {
    const key = params.row.action as ApiKeysModel;
    const handleButtonClick = () => handleDeleteApiKeyModalOpen(key);
    return (
      <Box sx={{ display: 'flex' }}>
        <Button color='error' startIcon={<MdDelete size='12' />} onClick={handleButtonClick}>
          Delete
        </Button>
      </Box>
    );
  };

  const gridColumns: GridColDef[] = [
    {
      field: 'name',
      headerName: 'Name',
      flex: 1,
    },
    {
      field: 'scope',
      headerName: 'Scopes',
      type: 'string',
      flex: 1,
    },
    {
      field: 'action',
      headerName: 'Action',
      renderCell: RenderDeleteButton,
      minWidth: 120,
      sortable: false,
      align: 'right',
    },
  ];

  const gridRows: GridRowsProp = apiKeys
    ? apiKeys.map((key) => ({
        name: key.desc,
        scope: key.scopes?.join(', '),
        action: key,
        id: key.self + key.createdAt,
      }))
    : [];

  return (
    <ControllerDataGrid
      sx={{ mt: 2 }}
      columns={gridColumns}
      disableSelectionOnClick
      disableColumnResize={false}
      components={{
        NoRowsOverlay: NoApiKeyOverlay,
      }}
      loading={!apiKeys}
      rows={gridRows}
      density='standard'
    />
  );
}

const NoApiKeyOverlay = () => (
  <Box
    sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100%',
    }}
  >
    <Typography fontWeight='bold' color='grayText'>
      No API keys configured
    </Typography>
  </Box>
);
